import { ChanelColors } from 'styled-components'

const colors: ChanelColors = {
  background: '#ffffff',
}

export default {
  colors,
}
